import { d as __spreadArray } from './tslib.es6-604585c1.js';
import IS_BROWSER from './isBrowser/index.js';
import { C as ConsentType } from './constants-3bc57a75.js';
import { createUseStyles } from 'react-jss';

var GoogleCallbackSource;
(function (GoogleCallbackSource) {
  GoogleCallbackSource["Button"] = "btn";
  GoogleCallbackSource["OneTap"] = "user";
})(GoogleCallbackSource || (GoogleCallbackSource = {}));

var data = {
  title: 'To get started:',
  privacyPolicy: 'TERMS_OF_USE_KR',
  ariaLabelPrivacyPolice: 'Read our privacy policy',
  mandatory: [{
    id: '1',
    consent: 'terms_of_use_consent',
    label: 'I have read and agree to the Terms of Use.'
  }, {
    id: '2',
    consent: 'above_14_age_consent',
    label: 'I confirm that I am 14 years or older.'
  }, {
    id: '3',
    consent: 'mandatory_pii_consent',
    label: 'I consent to the mandatory collection and use of personal information:',
    description: 'MANDATORY_PII_CONSENT'
  }],
  optionalTitle: 'Optional:',
  optional: [{
    id: '4',
    consent: 'optional_pii_consent',
    label: 'I consent to the optional collection and use of personal information:',
    description: 'OPTIONAL_PII_CONSENT'
  }, {
    id: '5',
    consent: 'pii_usage_and_collect_consent',
    label: 'I consent to the optional collection and use of personal information for receiving updates on Picsart products, services and events:',
    description: 'PII_USAGE_AND_COLLECT_CONSENT'
  }, {
    id: '6',
    consent: 'pii_usage_consent',
    label: 'I consent to receiving updates on Picsart products, services and events:',
    description: 'PII_USAGE_CONSENT'
  }]
};

var mandatory = data.mandatory,
  optional = data.optional;
var consents = __spreadArray(__spreadArray(__spreadArray([], mandatory, true), optional, true), [{
  id: ConsentType.biometric,
  consent: ConsentType.biometric
}, {
  id: ConsentType.marketing,
  consent: ConsentType.marketing
}], false);
var getIsMaximizer = function getIsMaximizer() {
  if (!IS_BROWSER) return false;
  var _a = window.location,
    pathname = _a.pathname,
    search = _a.search;
  var queryParams = new URLSearchParams(search);
  var isMaximizer = queryParams.get('maximizer') === 'true';
  return isMaximizer || pathname.includes('admaker') || pathname.includes('marketing');
};
var getConsents = function getConsents(checkedStates) {
  return checkedStates && consents.filter(function (item) {
    return checkedStates[item.id];
  }).map(function (item) {
    return item.consent;
  });
};

var useStyles = createUseStyles({
  '@global': {
    '#credential_picker_container': {
      top: '100px !important'
    },
    'input::-ms-reveal, input::-ms-clear': {
      display: 'none'
    }
  }
}, {
  name: 'one-tap'
});

export { GoogleCallbackSource as G, getIsMaximizer as a, data as d, getConsents as g, useStyles as u };
//# sourceMappingURL=styles-3006bf33.js.map
